import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../../mappers/common/common';
import { Bem } from '../../../service/Bem/Bem';
import { ValidationErrorData } from '../../../typings/common';
import { CurrencyLimitData } from '../../../typings/constants';
import { CurrencyCode } from '../../../typings/graphql-grid';
import { ErrorText, ErrorTextTheme } from '../../ErrorText/ErrorText';
import { NumberInput } from '../../NumberInput/NumberInput';
import { RequiredMark } from '../../RequiredMark/RequiredMark';

import './PhrasesSelectorRateEditor.css';
import * as keyset from './PhrasesSelectorRateEditor.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'phrases-selector-rate-editor';

export interface PhrasesSelectorRateEditorProps {
    rate?: number;
    rateLimit: CurrencyLimitData;
    error?: ValidationErrorData;
    workCurrency: CurrencyCode;
    onRawRateChange: (value: string) => void;
    onRateChange: (rate: number) => void;
}

export const PhrasesSelectorRateEditor = React.memo(
    ({ rate, workCurrency, error, rateLimit, onRateChange, onRawRateChange }: PhrasesSelectorRateEditorProps) => (
        <div className={Bem.cls(BLOCK)}>
            <div className={Bem.cls(BLOCK, 'price')}>
                <div className={Bem.cls(BLOCK, 'price-text')}>
                    {i18n('rate-note')}
                    <RequiredMark />
                </div>
                <div className={Bem.cls(BLOCK, 'price-input')}>
                    <NumberInput
                        key={'input'}
                        theme={'normal'}
                        size={'n'}
                        value={rate}
                        valid={!error}
                        onChange={onRawRateChange}
                        onValueChange={onRateChange}
                        errorText={<ErrorText theme={ErrorTextTheme.tooltip} errors={error ? [error] : undefined} />}
                    />
                </div>
                <span className={Bem.cls(BLOCK, 'currency')}>
                    {i18n('currency-cost-shows', {
                        currency: mapStringToCurrencySymbol(workCurrency)
                    })}
                </span>
            </div>
        </div>
    )
);
